<script lang="ts">
import SuperAdminLayout from "@/layouts/SuperAdminLayout.vue"

export default { layout: SuperAdminLayout }
</script>

<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3"
import { SbList, SbListItem, SbListLabel, SbListSection } from "@unio/saltbox-ui"
import { ref } from "vue"

import FlashAlerts from "@/components/FlashAlerts.vue"
import { ICON } from "@/lib/icons"
import { superAdminSettingsPath } from "@/routes"

export interface ProviderGroup {
  provider: string
  models: { id: string; name: string }[]
}

const props = defineProps<{
  ai_models: ProviderGroup[]
  current_ai_model_id: string
}>()

const selectedModel = ref(props.current_ai_model_id)
const saving = ref(false)

function onModelChange() {
  saving.value = true
  router.patch(
    superAdminSettingsPath(),
    { ai_model_id: selectedModel.value },
    { onFinish: () => (saving.value = false) },
  )
}
</script>

<template>
  <Head title="Settings — Admin" />

  <div class="flex flex-col gap-6">
    <FlashAlerts />

    <SbList bordered separator>
      <SbListItem>
        <SbListSection avatar>
          <UIcon :name="ICON.ai" class="text-muted size-5" />
        </SbListSection>
        <SbListSection>
          <SbListLabel>AI model</SbListLabel>
          <SbListLabel caption
            >Model used for image analysis in capture and item editing</SbListLabel
          >
        </SbListSection>
        <SbListSection side>
          <select
            v-model="selectedModel"
            class="text-highlighted w-48 rounded-md border border-(--ui-border) bg-(--ui-bg) px-2 py-1.5 text-sm"
            @change="onModelChange"
          >
            <optgroup v-for="group in ai_models" :key="group.provider" :label="group.provider">
              <option v-for="model in group.models" :key="model.id" :value="model.id">
                {{ model.name }}
              </option>
            </optgroup>
          </select>
        </SbListSection>
      </SbListItem>
    </SbList>
  </div>
</template>
